import React from 'react';
import { InputQ1Wrapper } from '../styles';
import CurrencyInputType from '../FieldType/CurrencyInputType';
import { UserDecimalSep } from 'models/user';
import utils from 'utils';
import actions from 'state/actions';
import { FieldInputType, FieldTriggerConfig } from 'models/response';

interface CurrencyInputProps {
  field: any;
  helpers: any;
  multi?: boolean;
  index?: number;
  label: string;
  readonly: boolean;
  feedbackColor: string;
  hasFeedback: boolean;
  feedbackMessage: string;
  separator: UserDecimalSep;
  decimalScale: number;
  config: any;
  autoViewInPage: () => void;
  dispatch: any;
  fieldInputType: FieldInputType;
  name: string;
  icon: JSX.Element;
  triggerConfig: FieldTriggerConfig | null;
  executeActionQ1: () => void;
}

export const CurrencyInputComponent: React.FC<CurrencyInputProps> = ({
  field,
  helpers,
  multi,
  index,
  label,
  readonly,
  feedbackColor,
  hasFeedback,
  feedbackMessage,
  separator,
  decimalScale,
  config,
  autoViewInPage,
  dispatch,
  fieldInputType,
  name,
  icon,
  triggerConfig,
  executeActionQ1,
}) => {
  const fieldValue =
    multi && (index || index === 0) ? field.value.content[index].content : field.value.content[0].content;

  const handleChange = (value: number | undefined) => {
    if (field.value) {
      const content = value === undefined ? '' : utils.intl.formatNumber(value, decimalScale, ',');
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content,
        pageNumber: -1,
        status: 0,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
      if (triggerConfig) executeActionQ1();
    }
  };

  const handleBlur = (value: number | undefined) => {
    if (field.value) {
      const content =
        config.val === 1 && value === 0
          ? ''
          : value !== undefined
          ? utils.intl.formatNumber(value, decimalScale, ',')
          : '';
      const arrayValues = [...field.value.content];
      arrayValues[multi && (index || index === 0) ? index : 0] = {
        ...field.value.content[multi && (index || index === 0) ? index : 0],
        content: content,
        status: 3,
      };
      helpers.setValue({
        ...field.value,
        content: arrayValues,
      });
    }
  };

  const onFocus = () => {
    autoViewInPage();
    field.value && dispatch(actions.documents.setFocussedQ1({ fieldInputType, name, multi, index }));
  };

  return (
    <InputQ1Wrapper multi={multi} margin={multi ? '0px 6px 0 18px' : '0 5px'}>
      <CurrencyInputType
        feedbackColor={feedbackColor}
        hasFeedback={hasFeedback}
        feedbackMessage={feedbackMessage}
        onFocus={onFocus}
        value={utils.intl.convertToNumber(fieldValue)}
        readonly={readonly}
        onChange={handleChange}
        onBlur={handleBlur}
        label={label}
        multi={multi}
        decimalSeparator={separator}
        decimalScale={decimalScale}
        width={multi ? '160px' : '200px'}
        margin={multi ? '0 5px' : '0 4px 0 0'}
      />
      {icon}
    </InputQ1Wrapper>
  );
};
